import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Order_Details_Card from "../order_details_card/Order_Details_Card";
import { useDispatch, useSelector } from "react-redux";
import { getAllReplaceOrder } from "../../../../features/order/orderSlice";
import { encodeId } from "../../../../utils/common";

const Replace = ({ type }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const order = useSelector((state) => state.order.allReturnOrders);

  useEffect(() => {
    const statusIds = [8];

    dispatch(
      getAllReplaceOrder({
        order_status_id: statusIds,
      }),
    );
  }, [dispatch]);

  const handleCardClick = (item) => {
    navigate(`/replace-order-details/${encodeId(item?.id)}?type=Replace`);
  };

  return (
    <section className="Return Ordered">
      {order?.data?.map((item) => {
        return (
          <Order_Details_Card
            data={item}
            type={type}
            key={item?.id}
            showTrackOrder={true}
            track_order_text="Order Replace Tracking"
            onClick={() => handleCardClick(item)}
            baseLike={`/replace-order-details/${encodeId(
              item?.id,
            )}?type=Replace`}
          />
        );
      })}

      <div className="no_data_main_div">
        <p className="no_data_text">No more orders to show</p>
      </div>
    </section>
  );
};

export default Replace;
